import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './i18n/config'
import './index.css'
import TagManager from 'react-gtm-module'

// Initialize Google Tag Manager with environment variable
const GTM_ID = process.env.REACT_APP_GTM_ID

if (GTM_ID) {
    const tagManagerArgs = {
        gtmId: GTM_ID,
    }
    TagManager.initialize(tagManagerArgs)
} else {
    console.warn('REACT_APP_GTM_ID environment variable is not set. GTM will not be initialized.')
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
